import React from 'react';
import { connect } from 'react-redux';

import ErrorPopUp from '../PopUps/ErrorPopUp';
import * as actions from '../../redux/actions/notification-actions';


class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
        };
        this.closePopup = this.closePopup.bind(this);
    }

    componentDidUpdate(oldProps) {
        if (this.props.notifications.popUp && !oldProps.notifications.popUp) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ showPopup: true });
        }
    }

    closePopup() {
        this.setState({
            showPopup: false,
        });
        this.props.dismissNotificationPopUp();
    }

    render() {
        const { custom, message, cta, description, showNoCta } = (this.props.notifications && this.props.notifications.popUp) || {};
        // console.log('Notifications props', this.props);
        return (
            <div>
                {(this.props.notifications && this.props.notifications.popUp && this.state.showPopup)
                    ? (
                        <ErrorPopUp
                            closePopup={this.closePopup}
                            custom={custom}
                            message={message}
                            cta={cta}
                            showNoCta={showNoCta}
                            description={description}
                        />
                    )
                    : <div />}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dismissNotificationPopUp: () => {
            dispatch(actions.dismissNotificationPopUp());
        },
    };
}

function mapStateToProps({ notifications }) {
    return { notifications };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
